import { render, staticRenderFns } from "./VeeamBackup.vue?vue&type=template&id=22668ccc&scoped=true&"
import script from "./VeeamBackup.vue?vue&type=script&lang=js&"
export * from "./VeeamBackup.vue?vue&type=script&lang=js&"
import style0 from "./VeeamBackup.vue?vue&type=style&index=0&id=22668ccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22668ccc",
  null
  
)

/* custom blocks */
import block0 from "./VeeamBackup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports